var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ZyroDrawer',{staticClass:"add-element-drawer"},[_c('p',{staticClass:"z-h5 add-element-drawer__title"},[_vm._v(" "+_vm._s(_vm.$t('common.addElements'))+" ")]),_c('AddElementList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }